module.exports = __webpack_public_path__ + "img/ic_head_hight_5.feeeaba2.png";